import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import i18n from "../../../../constants/i18n";
import getFlushHostsStore from "../../../../stores/developer-store/flush-hosts-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const FlushHostsForm = withLiteObserverAndTheme(() => {
  const flushHostsEmail = getFlushHostsStore().flushHostsEmail.get();
  const flushHostsPassword = getFlushHostsStore().flushHostsPassword.get();
  const flushHostsPassCode = getFlushHostsStore().flushHostsPassCode.get();
  const isEnabled = getFlushHostsStore().isFlushHostsFieldEmpty.get();

  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        icon={faEnvelope}
        type={"text"}
        label={i18n.get("EMAIL")}
        placeHolder={i18n.get("EMAIL")}
        value={flushHostsEmail}
        onChoose={(value: string) => {
          getFlushHostsStore().setFlushHostsEmail(value);
        }}
        onBlur={() => {}}
        style={{}}
        onEnter={() => {}}
      />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        icon={faLock}
        type={"password"}
        label={i18n.get("PASSWORD")}
        placeHolder={i18n.get("PASSWORD")}
        value={flushHostsPassword}
        onChoose={(value: string) => {
          getFlushHostsStore().setFlushHostsPassword(value);
        }}
        onBlur={() => {}}
        style={{}}
        onEnter={() => {}}
      />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        icon={faLock}
        type={"password"}
        label={i18n.get("PASSCODE")}
        placeHolder={i18n.get("PASSCODE")}
        value={flushHostsPassCode}
        onChoose={(value: string) => {
          getFlushHostsStore().setFlushHostsPassCode(value);
        }}
        onBlur={() => {}}
        style={{}}
        onEnter={() => {}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={isEnabled}
        onClick={async () => {
          getFlushHostsStore().flushHosts({
            email: flushHostsEmail,
            password: flushHostsPassword,
            passCode: flushHostsPassCode
          });
        }}
        size="LARGE"
        text="FLUSH_HOSTS"
        type="REJECT"
      />
    </React.Fragment>
  );
});

export default FlushHostsForm;
